export enum DischargeTypeEnum {
	ImprovedDischarge = 1,
	HealedDischarge = 2,
	Evasion = 3,
	DischargeOnDeath = 5,
	AdministrativeDischarge = 6,
	DischargeByTransfer = 7,
	DischargeOnMedicalAdvice = 8,
	DischargeOnRequest = 9,
}

export const dischargeTypeMessages = {
	[DischargeTypeEnum.ImprovedDischarge]: "Alta Melhorada",
	[DischargeTypeEnum.HealedDischarge]: "Alta Curada",
	[DischargeTypeEnum.Evasion]: "Evasão",
	[DischargeTypeEnum.DischargeOnDeath]: "Alta por Óbito",
	[DischargeTypeEnum.AdministrativeDischarge]: "Alta Administrativa",
	[DischargeTypeEnum.DischargeByTransfer]: "Alta por Transferência",
	[DischargeTypeEnum.DischargeOnMedicalAdvice]: "Alta por Indicação Médica",
	[DischargeTypeEnum.DischargeOnRequest]: "Alta a Pedido",
};
